<div class="aa-input-general">
  <div class="text-general-title mb-2 text-(--color-segundo)">
    {{ 'quotation.titles.destiny' | translate }}
  </div>
  <form [formGroup]="assetFormGroup" class="flex flex-col gap-1">
    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.titles.destiny' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full input-mat-form-field">
        <mat-select formControlName="assetType" (selectionChange)="onChangeAssetType($event)">
          @for (destination of destinations; track destination.id) {
            <mat-option [value]="destination.id">
              {{ destination.description }}
            </mat-option>
          }
        </mat-select>
        @if (assetFormGroup.controls['assetType'].hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.brand' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full input-mat-form-field">
        <mat-select formControlName="brand" (selectionChange)="onChangeBrand($event)">
          <mat-form-field class="w-full input-mat-form-field" appearance="outline">
            <input matInput (keyup)="filterBrand($event.target.value)" />
          </mat-form-field>
          @for (brand of brandsFilteredOptions; track brand.id) {
            <mat-option [value]="brand.id">
              {{ brand.description }}
            </mat-option>
          }
        </mat-select>
        @if (assetFormGroup.controls['brand'].hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.year' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full input-mat-form-field">
        <mat-select formControlName="year" (selectionChange)="onChangeYear($event)">
          @for (year of years; track year.description) {
            <mat-option [value]="year.description">
              {{ year.description }}
            </mat-option>
          }
        </mat-select>
        @if (assetFormGroup.controls['year'].hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="subtitle-content gap-1 flex flex-col">
      <mat-label class="text-(--comp-input-label-normal) px-4">{{
        'quotation.fieldNames.typeModel' | translate
      }}</mat-label>
      <mat-form-field appearance="outline" class="w-full input-mat-form-field">
        <mat-select formControlName="assetModel" (selectionChange)="onChangeAssetModel($event)">
          <mat-form-field class="w-full input-mat-form-field" appearance="outline">
            <input matInput (keyup)="filterModel($event.target.value)" />
          </mat-form-field>
          @for (model of modelsFilteredOptions; track model.id) {
            <mat-option [value]="model.id">
              {{ model.description }}
            </mat-option>
          }
        </mat-select>
        @if (assetFormGroup.controls['assetModel'].hasError('required')) {
          <mat-error>{{ 'Campo requerido' }}</mat-error>
        }
      </mat-form-field>
    </div>
    @if (othersSelected) {
      <div>
        <mat-form-field appearance="outline" class="w-full input-mat-form-field">
          <mat-label>{{ 'quotation.titles.assetDescription' | translate }}</mat-label>
          <mat-label>{{ 'quotation.titles.brand' | translate }}</mat-label>
          <input matInput formControlName="otherBrand" autocomplete="off" />
          @if (assetFormGroup.controls['otherBrand'].hasError('required')) {
            <mat-error>{{ 'Campo requerido' }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full input-mat-form-field">
          <mat-label>{{ 'quotation.fieldNames.assetType' | translate }}</mat-label>
          <input matInput formControlName="otherType" autocomplete="off" />
          @if (assetFormGroup.controls['otherType'].hasError('required')) {
            <mat-error>{{ 'Campo requerido' }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-full input-mat-form-field">
          <mat-label
            >{{ 'quotation.fieldNames.typeModel' | translate }}/{{
              'quotation.fieldNames.year' | translate
            }}</mat-label
          >
          <input matInput formControlName="otherModel" autocomplete="off" />
          @if (assetFormGroup.controls['otherModel'].hasError('required')) {
            <mat-error>{{ 'Campo requerido' }}</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </form>
</div>
